<app-rc-dialog-wrapper (closePopin)="cancel()">
  <div class="dialog_container">
    <div class="dialog_container__body">
      <!-- Image -->

      <div class="dialog_container__thumbs">
        <img src="assets/svg/wet-products.svg" alt="" />
      </div>

      <!-- Text -->
      <p class="dialog_container__body__message-1 rc-title-gamma">
        {{ 'product-reco_we-found-x-related-products' | translateKey: { x: product_count } }}
      </p>
      <p class="dialog_container__body__message-2" i18n="@@product-reco_combine-question">
        Do you want to combine a dry and a wet product in order for your pet to enjoy the benefits of mix feeding?
      </p>
    </div>

    <div class="dialog_container__footer">
      <rc-button data-qa="vs-combine-products-popin-button-yes" (click)="goForMixFeeding()">
        {{ 'action_yes_mix-feeding' | translateKey }}
      </rc-button>
      <span class="rc-button__separator" i18n="@@action_separator">or</span>
      <rc-link data-qa="vs-combine-products-popin-button-no" variant="secondary" size="large" (click)="cancel()">
        {{ 'action_no_thanks' | translateKey }}
      </rc-link>
    </div>
  </div>
</app-rc-dialog-wrapper>
